module.exports = __webpack_public_path__ + "static/media/accenture.d4afb78d.png";